export default "__VITE_ASSET__IHse2nTa__"